const runtimeConfig = typeof window !== 'undefined' ? (window.__APP_CONFIG__ ?? {}) : {};
const runtimePlaceholderPattern = /^__([A-Z0-9_]+)__$/;

const readConfig = (key, fallback = '') => {
  const runtimeValue = runtimeConfig[key];
  if (typeof runtimeValue === 'string' && runtimeValue.trim() !== '') {
    return runtimeValue.trim();
  }

  const buildTimeValue = process.env[key];
  if (
    typeof buildTimeValue === 'string' &&
    buildTimeValue.trim() !== '' &&
    !runtimePlaceholderPattern.test(buildTimeValue.trim())
  ) {
    return buildTimeValue.trim();
  }

  return fallback;
};

const appConfig = Object.freeze({
  apiBaseUrl: readConfig('REACT_APP_API_BASE_URL', 'http://localhost:8000/billing'),
  authBaseUrl: readConfig('REACT_APP_AUTH_BASE_URL', 'http://localhost:8000'),
  brandFaviconPath: readConfig('REACT_APP_BRAND_FAVICON_PATH', '/marmin_favicon.ico'),
  brandLogoPath: readConfig('REACT_APP_BRAND_LOGO_PATH', '/marmin_logo.png'),
  brandBackgroundImagePath: readConfig('REACT_APP_BRAND_BACKGROUND_IMAGE_PATH', '/signup_bg.svg'),
  brandName: readConfig('REACT_APP_BRAND_NAME', 'Marmin'),
  cookieDomain: readConfig('REACT_APP_COOKIE_DOMAIN') || undefined,
  marminRegion: readConfig('REACT_APP_MARMIN_REGION', 'UAE'),
  vendorName: readConfig('REACT_APP_VENDOR_NAME', 'marmin'),
  stripeCurrency: readConfig('REACT_APP_STRIPE_CURRENCY', 'AED'),
  timezoneName: readConfig('REACT_APP_TIMEZONE_NAME', 'Asia/Dubai'),
  appEnv: readConfig('REACT_APP_ENV_NAME', ''),
});

const TIN_PROVISION_UI_ENVS = new Set(['sandbox', 'staging', 'local']);

/** True when REACT_APP_ENV_NAME allows sandbox test TIN provisioning in the UI. */
export function isTinProvisionUiEnabled() {
  const env = appConfig.appEnv?.toLowerCase();
  return TIN_PROVISION_UI_ENVS.has(env);
}

const updateLinkHref = (selector, href) => {
  if (!href || typeof document === 'undefined') {
    return;
  }

  const linkElement = document.querySelector(selector);
  if (linkElement) {
    linkElement.href = href;
  }
};

export const applyDocumentBranding = () => {
  if (typeof document === 'undefined') {
    return;
  }

  document.title = `${appConfig.brandName} Billing Dashboard`;

  const descriptionElement = document.querySelector('meta[name="description"]');
  if (descriptionElement) {
    descriptionElement.setAttribute('content', `${appConfig.brandName} billing dashboard`);
  }

  updateLinkHref('link[rel="icon"]', appConfig.brandFaviconPath);
  updateLinkHref('link[rel="apple-touch-icon"]', appConfig.brandLogoPath);
};

export default appConfig;
